<template>
    <div class="para-container">
      <p>Ignite your business growth with a first-rate custom mobile application</p>
      <p>tailored to your needs. With our experienced team at the helm, you will</p>
      <p>exploit the power of leading technologies to enhance your customers’</p>
      <p>digital journey. Provide your audience with a one-of-a-kind User</p>
      <p>Experience on every mobile platform and device.</p>
      <div class="talk-btn">
        <LetsTalk/>
      </div>
    </div>
  </template>
  
  <script>
  import LetsTalk from '@/components/LetsTalk.vue';
  
  export default {
    name: 'AboutPara',
    components: {
      LetsTalk,
    }
  }
  </script>
  
  <style scoped>
  p {
    font-family: "Montserrat", sans-serif;
    font-weight: 400 !important;
    line-height: 25px !important;
    margin: 0; /* Remove default margin to eliminate space between headings */
    font-size: 16px;  
    margin: 0;
  }
  
  .para-container {
    padding-bottom: 40px; /* Add padding to the bottom of the container */
  }
  
  .talk-btn {
    margin-top: 20px; /* Move the button down */
  }
  </style>
  